import { createContext, useContext } from 'react';

import { type ScoringContextModel } from '@/models';

export interface ScoringContextType {
  updateScoringDataInComponent: (payload: ScoringContextModel | null) => void;
  clearScoringDataInLocalStorage: () => void;
  scoringData: ScoringContextModel;
}

export const ScoringContext = createContext<ScoringContextType | null>(null);
export const useScoringContext = (): ScoringContextType => useContext(ScoringContext) as ScoringContextType;
